import { Box, Typography } from "@mui/material";
import React from "react";
import TabHeading from "../../../common/tabs/TabHeading";
import { useDashLayoutCtx } from "../DashLayoutCtxProvider";
import SleepImage from "../../../../assets/svgs/sleep.svg";
import TruckListItem from "../../../common/list-item/TruckListItem";

const NoSavedTrucks = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
    }}
  >
    <Box
      sx={{
        height: "300px",
        width: "300px",
        overflow: "hidden",
        backgroundImage: `url(${SleepImage})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}
    />
    <Typography
      fontSize={"1.2rem"}
      fontWeight={500}
      sx={{
        mt: "20px",
      }}
    >
      No active trackings!
    </Typography>
    <Typography fontSize={"1rem"} fontWeight={400} sx={{ opacity: "0.6" }}>
      Start by creating a new tracking from trucks section.
    </Typography>
  </Box>
);

function SavedTrucks({ setRegNo }) {
  const { splitView, setsplitView, savedTrucks, settransferBin, transferBin } =
    useDashLayoutCtx();

  const onListItemClick = (obj) => {
    setRegNo(obj.vehRegNo);
    setsplitView(true);
    settransferBin(obj);
  };
  return (
    <Box
      sx={{
        height: "calc(100% - 40px)",
        margin: "20px",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <TabHeading heading="Saved Trucks" />
      <Box
        sx={{
          width: "100%",
          flexGrow: 1,
          mt: "20px",
          overflowY: "auto",
        }}
      >
        {savedTrucks?.map((item, index) => {
          return (
            <TruckListItem
              key={index}
              vehRegNo={item.rc_no}
              ownerName={item.owner_name || ""}
              mnfcName={item.maker_desc || ""}
              id={index}
              onClickFunc={onListItemClick}
              compactMode={splitView ? true : false}
              selectedItem={transferBin?.vehRegNo === item.rc_no}
              hideDivider={index === savedTrucks.length - 1}
              showTrackingChip={false}
            />
          );
        })}
        {savedTrucks?.length === 0 && <NoSavedTrucks />}
      </Box>
    </Box>
  );
}

export default SavedTrucks;
